import { useNavigate } from "react-router-dom";
import { Award, Clock, Building2, ShieldCheck, ArrowRight } from "lucide-react";

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/48bc66d4-e137-48bf-811d-bee5c078c182/images/b2c0a35bff307b59c3365e289cc94d287811f148d9394a1f5bff712699b57cc3.jpeg";

const TRUST = [
    { Icon: Award, text: "Premio IFAI 2021" },
    { Icon: Clock, text: "+20 años" },
    { Icon: Building2, text: "+10,000 techos" },
    { Icon: ShieldCheck, text: "Garantía por escrito" },
];

export default function Hero() {
    const navigate = useNavigate();

    return (
        <section data-testid="hero-section" className="relative min-h-[100vh] flex items-end overflow-hidden">
            <img
                src={HERO_IMG}
                alt="Plaza comercial con velarias premium Eclipse Cubiertas en Monterrey, México"
                className="absolute inset-0 w-full h-full object-cover object-center z-0"
                width="1920"
                height="1080"
                loading="eager"
                fetchpriority="high"
                decoding="async"
            />
            {/* Dramatic gradient: dark left, fading right */}
            <div className="absolute inset-0 z-10" style={{ background: "linear-gradient(100deg, rgba(10,10,10,0.92) 0%, rgba(10,10,10,0.78) 30%, rgba(10,10,10,0.45) 65%, rgba(10,10,10,0.18) 100%)" }} aria-hidden />
            <div className="absolute inset-0 z-10" style={{ background: "linear-gradient(to top, rgba(10,10,10,0.85) 0%, rgba(10,10,10,0.25) 60%, rgba(10,10,10,0) 100%)" }} aria-hidden />

            <div className="relative z-20 container-eclipse pt-32 pb-16 sm:pb-24 w-full">
                <div className="max-w-5xl">
                    <p data-testid="hero-eyebrow" className="font-display font-bold text-xs sm:text-sm tracking-[0.3em] text-eclipse-cta mb-5 fade-up">ECLIPSE CUBIERTAS · MÉXICO · PREMIO IFAI 2021</p>
                    <h1
                        data-testid="hero-title"
                        className="font-display font-black text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight mb-6 fade-up"
                        style={{ animationDelay: "0.1s" }}
                    >
                        Líderes en<br />
                        <span className="text-eclipse-cta">Cubiertas Textiles</span><br />
                        <span className="text-white/95">en México</span>
                    </h1>
                    <p data-testid="hero-subtitle" className="text-white/90 text-base sm:text-lg lg:text-xl max-w-2xl leading-relaxed mb-10 fade-up" style={{ animationDelay: "0.2s" }}>
                        Diseño, fabricación e instalación de malla sombra, velarias y tensoestructuras. Más de 20 años. Más de 10,000 techos instalados en Latinoamérica.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 fade-up" style={{ animationDelay: "0.3s" }}>
                        <button data-testid="hero-flexshade-cta" onClick={() => navigate("/flexshade")} className="btn-eclipse-cta inline-flex items-center justify-center gap-2 px-7 py-4 rounded-sm text-sm tracking-wider uppercase">
                            FlexShade — Toldos modulares <ArrowRight className="w-4 h-4" />
                        </button>
                        <button data-testid="hero-skycover-cta" onClick={() => navigate("/velarias")} className="btn-eclipse-outline inline-flex items-center justify-center gap-2 px-7 py-4 rounded-sm text-sm tracking-wider uppercase">
                            Skycover — Premium <ArrowRight className="w-4 h-4" />
                        </button>
                    </div>
                </div>

                <div data-testid="hero-trust-bar" className="mt-16 sm:mt-20 grid grid-cols-2 sm:grid-cols-4 gap-6 pt-8 border-t border-white/15 fade-up" style={{ animationDelay: "0.4s" }}>
                    {TRUST.map(({ Icon, text }) => (
                        <div key={text} className="flex items-center gap-3" data-testid={`hero-trust-${text.toLowerCase().replace(/\s|\+/g, "-")}`}>
                            <Icon className="w-5 h-5 text-eclipse-cta flex-shrink-0" strokeWidth={1.75} />
                            <span className="text-white/90 text-xs sm:text-sm font-medium">{text}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
